module.exports = __webpack_public_path__ + "static/media/turner_kennedy_pusins.9b207513.jpg";